module.exports = __webpack_public_path__ + "img/transition_img.090eb0b6.jpg";